import * as Preact from "preact"

import App from "@fae/source/models/App.js"
import Stage from "@fae/source/models/Stage.js"
import Geometry from "@fae/source/utility/Geometry.js"

import CarryOn from "@fae/source/data/games/ember/utility/CarryOn.js"
import * as PlotSteps from "@fae/source/data/plot/steps.js"
import Audiomix from "@fae/source/engine/Audiomix.js"

import "./Huds.less"

function canReroll(stage) {
    return stage.player.rollcount >= 1
        && Object.values(stage.units).filter((unit) => {
            return unit.isDead != true
                && unit.isLockedIn != true
                && unit.affiliation == stage.player.affiliation
                && Geometry.isInBounds(stage.encounters[stage.currentEncounterKey], unit.position)
        }).length > 0
}

function onClickDone(stage) {
    return function(event) {
        Object.values(stage.units).forEach((unit) => {
            delete unit.isLockedIn
        })

        stage.player.phase = "playing"
        stage.player.zoomout = 1
        delete stage.steps // TODO: this SHOULD be an empty array, but it isn't always. why??
        Stage.calculateActions(stage, {"force": true})
    }
}

export default function RollingHud(stage) {
    return (
        <div class="RollingHud" isVisible={App.game?.chapter?.selection.isRerolling}>
            <div class="Text">Pick up to {stage.player.rollcount} dice to reroll.</div>
        </div>
    )
    if(stage.player.phase != "rolling") return
    if(stage.flags.hud == false) return
    return (
        <div class="RollingHud">
            <div class="DoneButton" onClick={onClickDone(stage)} isEnabled={true} isHighlighted={canReroll(stage) == false}>Done</div>
            <div class="RerollButton" isEnabled={canReroll(stage) == true}>
                Rerolls: {stage.player.rollcount}
            </div>
        </div>
    )
}
